import React, {useEffect, useState} from "react";
import DashboardSidebar from "../components/DashboardSidebar";
//import TableViewer from "../components/TableViewer";
import "../styles/DashboardPage.css";
import axios from "axios";
import DynamicTable from "../components/DynamicTable";
import TermCreateForm from "../Forms/TermCreateForm";
import CourseCreateForm from "../Forms/CourseCreateForm";
//import ParticipantCreateForm from "../Forms/ParticipantCreateForm";
import StudentCreateForm from "../Forms/StudentCreateForm";
import QuestionForm from "../Forms/QuestionForm";
import QuestionGroupForm from "../Forms/QuestionGroupForm";
import ExamForm from "../Forms/ExamForm";
import CourseDetailsForm from "../Forms/CourseDetailsForm";
import PredictionForm from "../Forms/PredictionForm";

export default function DashboardPage() {
    //const [data, setData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [examId, setExamId] = useState("");
    const [participantId, setParticipantId] = useState("");
    const [studentId, setStudentId] = useState("");
    const [courseId, setCourseId] = useState("");
    const [exams, setExams] = useState([]);
    const [students, setStudents] = useState([]);
    const [courses, setCourses] = useState([]);
    const [tableHeader, setTableHeader] = useState([]);
    // tabs which not contain table
    const antiTableTabs = [
        "course_create",
        "term_create",
        "participant_create",
        "student_create",
        "question_create",
        "question_group_create",
        "exam_create",
        "course_details_add",
        "prediction"
    ];


    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/exams`)
            .then(res => setExams(res.data))
            .catch(() => setExams([]));

        axios.get(`${process.env.REACT_APP_API_URL}/students/all`)
            .then(res => setStudents(res.data))
            .catch(() => setStudents([]));

        axios.get(`${process.env.REACT_APP_API_URL}/courses`)
            .then(res => setCourses(res.data))
            .catch(() => setCourses([]));

    }, []);


    const [activeTab, setActiveTab] = useState("");
    useEffect(() => {
        setExamId("");
        setStudentId("");
        setParticipantId("");
        setCourseId("");
        setTableData([]);
    }, [activeTab]);

    // student id ye bağlı participant id çağır
    useEffect(() => {
            if (!studentId) return;
            setLoading(true);
            axios.get(`${process.env.REACT_APP_API_URL}/course-participants/get-by-student-id/${studentId}`)
                .then(res => {
                    console.log("Participant ID fetched:", res.data);
                    setParticipantId(res.data.id || "");
                })
                .catch(() => {
                    setParticipantId("");
                })
                .finally(() => setLoading(false));
        }
        , [studentId]);

    // API'den veri çek
    useEffect(() => {
        if (!activeTab) return; // activeTab boşsa çıkış yap

        setLoading(true);

        let url = "";

        switch (activeTab) {
            // Katılımcılar
            case "participants_all":
                url = `${process.env.REACT_APP_API_URL}/students/all`;
                break;
            case "periods_all":
                url = `${process.env.REACT_APP_API_URL}/terms`;
                break;
            case "courses_all":
                url = `${process.env.REACT_APP_API_URL}/courses`;
                break;

            // Sınavlar
            case "exams_all":
                url = `${process.env.REACT_APP_API_URL}/exams`;
                break;

            // Sorular
            case "questions":
                url = `${process.env.REACT_APP_API_URL}/questions/all`;
                break;

            // Soru Grupları
            case "question_groups":
                url = `${process.env.REACT_APP_API_URL}/question-groups`;
                break;

            case "exam_results":
                url = `${process.env.REACT_APP_API_URL}/exam-results/8`;
                break;

            case "exam_results_by_exam":
                if (!examId) {
                    setLoading(false);
                    return; // examId yoksa veri çekme
                }
                url = `${process.env.REACT_APP_API_URL}/exam-results/dashboard/by-exam?examId=${examId}`;
                break;

            case "exam_results_by_participant":
                if (!participantId) {
                    setLoading(false);
                    return; // participantId yoksa veri çekme
                }
                url = `${process.env.REACT_APP_API_URL}/exam-results/dashboard/by-participant?participantId=${participantId}`;
                break;

            case "course_details_all":
                url = `${process.env.REACT_APP_API_URL}/course-details`;
                break;

            case "course_participants_by_course":
                if (!courseId) {
                    setLoading(false);
                    return; // courseId yoksa veri çekme
                }
                url = `${process.env.REACT_APP_API_URL}/course-participants/get-by-course-id/${courseId}`;
                break;

            default:
                setLoading(false);
                return;
        }

        if (url && activeTab !== "answer_details") {
            axios.get(url)
                .then((res) => {
                    console.log(`${activeTab} data fetched:`, res.data);
                    setTableData(res.data);
                })
                .catch((err) => {
                    console.error("Veri alınamadı:", err);
                    setTableData([]);
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, [activeTab, examId, participantId, courseId]);

    const handleFetchAnswerDetails = () => {
        if (!examId || !participantId) return;
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}/exam-answers/details?examId=${examId}&participantId=${participantId}`)
            .then((res) => setTableData(res.data))
            .catch((err) => {
                console.error("Veri alınamadı:", err);
                setTableData([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        switch (activeTab) {
            case "participants_all":
                setTableHeader(["Tüm Kullanıcılar"]);
                break;
            case "periods_all":
                setTableHeader(["DÖNEMLER"]);
                break;
            case "courses_all":
                setTableHeader(["Tüm Kurslar"]);
                break;
            case "exams_all":
                setTableHeader(["Tüm Sınavlar"]);
                break;
            case "questions":
                setTableHeader(["Tüm Sorular"]);
                break;
            case "question_groups":
                setTableHeader(["Soru Grupları"]);
                break;
            case "exam_results_by_exam":
                setTableHeader(["Sınav Sonuçları"]);
                break;
            case "exam_results_by_participant":
                setTableHeader(["Sınav Sonuçları (Katılımcı Bazlı)"]);
                break;
            case "answer_details":
                setTableHeader(["Soru Yanıtları (Detaylı)"]);
                break;
            case "course_details_all":
                setTableHeader(["Tüm Kurs Detayları"]);
                break;

            case "course_participants_by_course":
                setTableHeader(["Kursa Kayıtlı Katılımcılar"]);
                break;


            default:
                setTableHeader([]);
                break;
        }
    }, [activeTab]);


    // Katılımcı onaylama fonksiyonu
    const handleParticipantAction = async (action, participant) => {
        if (action === 'enable') {
            const confirmMessage = `${participant.fullName} adlı katılımcıyı onaylamak istediğinizden emin misiniz?`;
            if (!window.confirm(confirmMessage)) {
                return;
            }

            setLoading(true);
            try {
                const response = await axios.put(`${process.env.REACT_APP_API_URL}/course-participants/enable/${participant.id}`);

                if (response.status === 200) {
                    alert('✅ Katılımcı başarıyla onaylandı!');

                    // Tabloyu güncelle - onaylanan katılımcının enabled durumunu true yap
                    setTableData(prevData =>
                        prevData.map(item =>
                            item.id === participant.id
                                ? { ...item, enabled: true }
                                : item
                        )
                    );
                } else {
                    alert('❌ Onaylama işlemi başarısız oldu.');
                }
            } catch (error) {
                console.error('Katılımcı onaylama hatası:', error);
                alert('🔌 Bağlantı hatası. Lütfen tekrar deneyin.');
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <>
            <div className="dashboard-container">

                <DashboardSidebar onMenuSelect={setActiveTab}/>
                <main className="dashboard-content">
                    <h1 className="dashboard-title">{tableHeader}</h1>
                    {/*select bars according to exam table*/}
                    {activeTab === "exam_results_by_exam" && (
                        <select value={examId} onChange={e => setExamId(e.target.value)}>
                            <option value="">Sınav seçiniz</option>
                            {exams
                                .slice()
                                .sort((a, b) => {
                                    const examA = (a.name || a.examName || "").toLowerCase();
                                    const examB = (b.name || b.examName || "").toLowerCase();
                                    return examA.localeCompare(examB, "tr");
                                })
                                .map(exam => (
                                    <option key={exam.id} value={exam.id}>
                                        {exam.name || exam.examName}
                                    </option>
                                ))}
                        </select>

                    )}

                    {activeTab === "exam_results_by_participant" && (
                        <select value={studentId} onChange={e => setStudentId(e.target.value)}>
                            <option value="">Öğrenci seçiniz</option>
                            {students
                                .slice() // Orijinal diziyi bozmamak için kopya al
                                .sort((a, b) => {
                                    const nameA = (a.firstName + " " + a.lastName).toLowerCase();
                                    const nameB = (b.firstName + " " + b.lastName).toLowerCase();
                                    return nameA.localeCompare(nameB, "tr");
                                })
                                .map(student => (
                                    <option key={student.id} value={student.id}>
                                        {student.firstName} {student.lastName}
                                    </option>
                                ))}
                        </select>

                    )}

                    {/*exam answer selects*/}
                    {activeTab === "answer_details" && (
                        <div style={{display: "flex", gap: 16, alignItems: "center"}}>
                            <select value={examId} onChange={e => setExamId(e.target.value)}>
                                <option value="">Sınav seçiniz</option>
                                {exams
                                    .slice()
                                    .sort((a, b) => {
                                        const examA = (a.name || a.examName || "").toLowerCase();
                                        const examB = (b.name || b.examName || "").toLowerCase();
                                        return examA.localeCompare(examB, "tr");
                                    })
                                    .map(exam => (
                                        <option key={exam.id} value={exam.id}>
                                            {exam.name || exam.examName}
                                        </option>
                                    ))}
                            </select>

                            <select value={studentId} onChange={e => setStudentId(e.target.value)}>
                                <option value="">Öğrenci seçiniz</option>
                                {students
                                    .slice() // Orijinal diziyi bozmamak için kopya al
                                    .sort((a, b) => {
                                        const nameA = (a.firstName + " " + a.lastName).toLowerCase();
                                        const nameB = (b.firstName + " " + b.lastName).toLowerCase();
                                        return nameA.localeCompare(nameB, "tr");
                                    })
                                    .map(student => (
                                        <option key={student.id} value={student.id}>
                                            {student.firstName} {student.lastName}
                                        </option>
                                    ))}
                            </select>

                            <button
                                className="export-button"
                                onClick={() => {
                                    console.log("examId", examId, "participantId", participantId);
                                    ;handleFetchAnswerDetails()
                                }} // yüklenmeyi tetikler
                            >
                                Getir
                            </button>
                        </div>
                    )}
                    {activeTab === "course_details_all" && (
                        <select value={examId} onChange={e => setExamId(e.target.value)}>
                            <option value="">Kurs seçiniz</option>
                            {tableData
                                .slice()
                                .sort((a, b) => {
                                        const courseA = (a.name || a.courseName || "").toLowerCase();
                                        const courseB = (b.name || b.courseName || "").toLowerCase();
                                        return courseA.localeCompare(courseB, "tr");
                                    }
                                )
                                .map(course => (
                                    <option key={course.id} value={course.id}>
                                        {course.name || course.courseName}
                                    </option>
                                ))}
                        </select>
                    )}


                    {activeTab === "course_participants_by_course" && (
                        <select value={courseId} onChange={e => setCourseId(e.target.value)}>
                            <option value="">Kurs seçiniz</option>
                            {courses
                                .slice()
                                .sort((a, b) => {
                                    const courseA = (a.name || a.courseName || "").toLowerCase();
                                    const courseB = (b.name || b.courseName || "").toLowerCase();
                                    return courseA.localeCompare(courseB, "tr");
                                })
                                .map(course => (
                                    <option key={course.id} value={course.id}>
                                        {course.name || course.courseName}
                                    </option>
                                ))}
                        </select>
                    )}

                    {activeTab === "term_create" && <TermCreateForm/>}
                    {activeTab === "course_create" && <CourseCreateForm/>}
                    {activeTab === "student_create" && <StudentCreateForm/>}
                    {activeTab === "question_create" && <QuestionForm/>}
                    {activeTab === "question_group_create" && <QuestionGroupForm/>}
                    {activeTab === "exam_create" && <ExamForm/>}
                    {activeTab === "course_details_add" && <CourseDetailsForm/>}
                    {activeTab === "prediction" && <PredictionForm/>}


                    {/*<TableViewer view={activeTab}/>*/}
                    {!antiTableTabs.includes(activeTab) && (
                        loading ? (
                            <p>Yükleniyor...</p>
                        ) : (
                            <DynamicTable
                                data={tableData}
                                onAction={activeTab === "course_participants_by_course" ? handleParticipantAction : null}
                            />
                        )
                    )}

                </main>
            </div>
        </>

    );
}
